/**
 * @module ConstructorIO/recommendations
 */

import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';
import {processProductRecommendations} from './helpers/result';

/**
 *  Class wrapping the Constructor.io recommendations functionality.
 */
export default class ConstructorIORecommendations {
    #maxResult = null;

    #filters = null;

    #client = null;

    #variations_map = null;

    constructor(maxResults = 10) {
        this.#client = new ConstructorIOClient({
            apiKey: window.CONSTRUCTOR_API_KEY,
            userId: window.customer && window.customer.customerNo
        });

        this.#maxResult = maxResults;
        const filters = {};
        filters[`available_${window.Constants.SITE_ID}`] = 'True';
        this.#filters = filters;

        this.#variations_map = {
            values: {variation_ids: {aggregation: 'all', field: 'data.variation_id'}},
            dtype: 'array'
        };
    }

    /**
     * @param {string} podId - podId in constructor
     * @param {Array} itemIds - product ids for the recommendation
     * @returns {{products: Array<Object>|null}} recommendations or null
     */
    async getRecommendations(podId, itemIds = []) {
        try {
            if (!podId) {
                return {
                    products: null
                };
            }
            const returnObject = await this.#client.recommendations.getRecommendations(podId, {
                numResults: this.#maxResult,
                filters: this.#filters,
                variationsMap: this.#variations_map,
                itemIds
            });

            if (returnObject.response.results.length === 0) {
                return {
                    products: null
                };
            }

            const products = processProductRecommendations(returnObject.response.results);

            return {
                products,
                result_id: returnObject.result_id,
                pod_id: podId,
                pod_display_name: returnObject.response.pod?.display_name
            };
        } catch (error) {
            console.error(error);
            return {
                products: null
            };
        }
    }
}
